"use client"

import { useState, useEffect } from "react"
import { Card, CardContent } from "../ui/card";
import { Star, Quote } from "lucide-react";
import Madankishore from "../images/madankishore testimonal.png"
import GOVIND from "../images/GOVIND testimonal.png"
import Murali from "../images/Murali testimonal.png"
import Raja from "../images/Raja testimonal.png"
import Krishna from "../images/Murali testimonal.png"

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0)

  const testimonials = [
    {
      id: 1,
      name: "madankishore panchangam",
      location: "Bachupally",
      rating: 5,
      text: "What I feel is excellent hospital in all aspects especially team of doctors.. My father spent almost six days in the hospital for lung infection. Undoubtedly I suggest this hospital for any issue. Only issue we faced is ward boys but supervisor venkatesh garu and lady supervisor they helped very well. Requesting management to take quick preventive measures during workers strike otherwise patients will suffer. Overall experience is good.Thanq MAMS.",
      treatment: "Lung Infection",
      image: Madankishore,
      
    },
    {
      id: 2,
      name: "Govind Yadav",
      location: "Bachupally",
      rating: 5,
      text: "Very good hospital in bachupally. I Really felt very happy by Dr Akshay sir and Dr Divya ma'am. The way they treat the patient is really awesome. I am so happy to be such doctor's in the hospital. Thank you so much Dr Akshay sir and team.",
      treatment: "Emergency Care",
      image: GOVIND,
    },
    {
      id: 3,
      name: "Milind Bhandarkar",
      location: "Bachupally",
      rating: 5,
      text: "One of the best Treatment by doctor and supporting Staff, first Time I came to Hyderabad feels good during Treatment for my Daughter.Good supporting Staff.Thanks Mamta Hospital Doctor and Staff.",
      treatment: "Emergency Care",
      image: Murali,
    },
    {
      id: 4,
      name: "Raja Maddala",
      location: "Bachupally",
      rating: 4,
      text: "Mams Hospital offers exceptional treatment and scanning services in a warm, welcoming environment. The staff are compassionate and professional, ensuring every patient feels cared for. The hospital is clean, well-maintained, and equipped with modern technology, making it a reliable choice for quality healthcare.",
      treatment: "Emergency Care",
      image: Raja,
    },
    {
      id: 5,
      name: "Murali Krishna yannam",
      location: "Bachupally",
      rating: 5,
      text: "I feel like it is an excellent hospital. In this hospital the doctors are too good and they treating patients like a family . The hospital staff is very respectful and responsible. Especially having great experience with radiology department.",
      treatment: "Radiology",
      image: Krishna,
    },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [testimonials.length])

  return (
    <section className="py-8 md:py-16 px-0 md:px-4  bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-2">What Our Patients Say</h2>
          <p className="text-apple-gray-400 max-w-2xl mx-auto">
            Real stories from real patients who have experienced exceptional care at MAMS Hospitals.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <Card className="border-apple-gray-100 rounded-3xl overflow-hidden shadow-lg">
            <CardContent className="p-8 md:p-12">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="flex-shrink-0">
                  <img
                    src={testimonials[currentTestimonial].image || "/placeholder.svg"}
                    alt={testimonials[currentTestimonial].name}
                    className="w-20 h-20 rounded-full object-cover border-4 border-apple-teal/20"
                  />
                </div>

                <div className="flex-1 text-center md:text-left">
                  <Quote className="h-8 w-8 text-apple-teal/30 mb-4 mx-auto md:mx-0" />

                  <p className="text-lg md:text-xl text-apple-gray-400 mb-6 italic">
                    "{testimonials[currentTestimonial].text}"
                  </p>

                  <div className="flex items-center justify-center md:justify-start gap-1 mb-4">
                    {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>

                  <div>
                    <div className="font-semibold text-apple-gray-500 text-lg">
                      {testimonials[currentTestimonial].name}
                    </div>
                    <div className="text-apple-gray-300 text-sm">
                      {testimonials[currentTestimonial].location} • {testimonials[currentTestimonial].treatment}
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Dots Navigation */}
          <div className="flex justify-center mt-8 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentTestimonial ? "bg-apple-teal" : "bg-apple-gray-200 hover:bg-apple-gray-300"
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
          <div className="text-center">
            <div className="text-3xl font-bold text-apple-teal mb-2">98%</div>
            <div className="text-apple-gray-400">Patient Satisfaction</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-apple-teal mb-2">50,000+</div>
            <div className="text-apple-gray-400">Happy Patients</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-apple-teal mb-2">4.8/5</div>
            <div className="text-apple-gray-400">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-apple-teal mb-2">30+</div>
            <div className="text-apple-gray-400">Years of Trust</div>
          </div>
        </div>
      </div>
    </section>
  )
}
